import { render, staticRenderFns } from "./SubscriptionPricing.vue?vue&type=template&id=a906f740&scoped=true"
import script from "./SubscriptionPricing.vue?vue&type=script&lang=js"
export * from "./SubscriptionPricing.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPricing.vue?vue&type=style&index=0&id=a906f740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a906f740",
  null
  
)

export default component.exports